import React, { useState, useEffect, useMemo } from "react";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import { hardwareData } from "variables/MBM/lists/equipments";
import { automationText } from "variables/MBM/geb";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import DataTable from "react-data-table-component";
import { dico } from "variables/lists/dico";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;
const EquipmentDetails = styled.div`
  margin-right: auto;
  margin-left: -8px;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const EquipmentButton = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
cursor: pointer;
`;
function EquipmentsDialog(props) {
  const { closeModal, equipments, equipmentsData, setEquipments, fullpointdata, setEquipmentatatype } = props;


  const [filteredHardwareData, setFilteredHardwareData] = useState(hardwareData);
  const [preselectedEquipments, setPreselectedEquipments] = useState([]);
  const [prefilteredEquipments, setPrefilteredEquipments] = useState([]);
  const [type, setType] = useState("all");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [selectedequipments, setSelectedequipments] = useState([]);


  const handleTypeChange = (event) => {
    setType(event.target.value);
  };

  useEffect(() => {
    let tmpprefilteredEquipments = [...equipmentsData];
    if (type !== 'all') {
      tmpprefilteredEquipments = tmpprefilteredEquipments.filter((equipment) => equipment.otherproperties?.hardware ? equipment.otherproperties.hardware === type : type === -1);
    }
    setPrefilteredEquipments(tmpprefilteredEquipments);
  }, [type, equipmentsData]);

  useEffect(() => {
    let tmphardwaredata = hardwareData.filter((hw) =>
      equipmentsData.some((eq) => eq.otherproperties?.hardware && eq.otherproperties.hardware === hw.id) || hw.id === -1
    );
    // console.log([...tmphardwaredata]);
    tmphardwaredata.unshift({ id: "all", name: automationText.allmodels })
    // console.log([...tmphardwaredata]);
    setFilteredHardwareData(tmphardwaredata);

    // let selectedequipmentstmp = equipmentsData.filter((eq) =>
    //   equipments.some((selectedeq) => selectedeq.id == eq.id)
    // );
    // setSelectedequipments(selectedequipmentstmp);

    setSelectedequipments(equipments);
  }, []);

  const classes = useStyles();


  const handleSubmit = (event) => {
    let tmpdatatype = [];
    selectedequipments.forEach((eq) => {
      let eqpoints = fullpointdata.filter((p) => p.equipment == eq.id);
      eqpoints.forEach((pt) => {
        if (!tmpdatatype.find((dt) => dt.id === pt.definition)) {
          let type = dico.find((d) => d.id == pt.definition);
          if (type) {
            tmpdatatype.push({ id: pt.definition, unit: type.unit, name: type.equipmentname + " - " + type.name, equipmentcount: 1 });
          }
        }
        else {
          tmpdatatype.find((dt) => dt.id === pt.definition).equipmentcount++;
        }
      });
    });
    setEquipmentatatype(tmpdatatype);
    setEquipments(selectedequipments);
    closeModal();
  };

  const equipmentsColumns = [
    {
      name: automationText.equipmentname,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name
    },
    {
      name: automationText.hardware,
      selector: (row) => row.otherproperties?.hardware ? hardwareData.find((a) => a.id == row.otherproperties.hardware)?.name || automationText.undefinedhardware : automationText.undefinedhardware,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.otherproperties?.hardware ? hardwareData.find((a) => a.id == row.otherproperties.hardware)?.name || automationText.undefinedhardware : automationText.undefinedhardware
    },
    {
      name: automationText.included,
      selector: (row) => selectedequipments.find((eq) => eq.id === row.id) ? automationText.confirmyes : automationText.confirmno,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => selectedequipments.find((eq) => eq.id === row.id) ? automationText.confirmyes : automationText.confirmno
    },
    // {
    //   name: vuepagetext.equipmentgranularity,
    //   selector: (row) => row.granularity,
    //   sortable: true,
    //   cell: (row) => equipmentgranularityfullData.find((a) => a.id == row.granularity)?.name || ""
    // },
  ]

  const handleOnRowClicked = (row) => {
    let tmpNewselectedequipments = [...selectedequipments];
    let index = tmpNewselectedequipments.findIndex((eq) => eq.id === row.id);
    if (index > -1) { // only splice array when item is found
      tmpNewselectedequipments.splice(index, 1); // 2nd parameter means remove one item only
    }
    else {
      tmpNewselectedequipments.push({ id: row.id, hardware: row.otherproperties?.hardware || -1 });
    }
    setSelectedequipments(tmpNewselectedequipments);
  }

  const handleSelectAll = () => {
    let tmpNewselectedequipments = [...selectedequipments];
    filteredItemsEquipments.forEach((filteq) => {
      if (!tmpNewselectedequipments.find((eq) => eq.id === filteq.id)) {
        tmpNewselectedequipments.push({ id: filteq.id, hardware: filteq.otherproperties?.hardware || -1 })
      }
    })
    setSelectedequipments(tmpNewselectedequipments);
  }

  const handleUnselectAll = () => {
    let tmpNewselectedequipments = [...selectedequipments];
    filteredItemsEquipments.forEach((filteq) => {
      let index = tmpNewselectedequipments.findIndex((eq) => eq.id === filteq.id);
      if (index > -1) { // only splice array when item is found
        tmpNewselectedequipments.splice(index, 1); // 2nd parameter means remove one item only
      }
    })
    setSelectedequipments(tmpNewselectedequipments);
  }

  const [filterTextEquipment, setFilterTextEquipment] = useState("");
  const [resetPaginationToggleEquipment, setResetPaginationToggleEquipment] = useState(false);
  const SearchComponentEquipment = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );
  const filteredItemsEquipments = prefilteredEquipments.filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterTextEquipment.toLowerCase()))
  );
  const subHeaderComponentMemoEquipment = useMemo(() => {
    const handleClearEquipment = () => {
      if (filterTextEquipment) {
        setResetPaginationToggleEquipment(!resetPaginationToggleEquipment);
        setFilterTextEquipment("");
      }
    };
    const onFilterTextEquipment = (e) => setFilterTextEquipment(e.target.value);

    return (
      <>
        <EquipmentDetails>
          <div>{automationText.includedlength + " : " + selectedequipments.length}</div>
          <EquipmentButton onClick={handleSelectAll}>{automationText.selectall}</EquipmentButton>
          <EquipmentButton onClick={handleUnselectAll}>{automationText.unselectall}</EquipmentButton>
        </EquipmentDetails>
        <SearchComponentEquipment
          key="SearchComponentEquipment"
          onFilter={onFilterTextEquipment}
          onClear={handleClearEquipment}
          filterText={filterTextEquipment}
        />

      </>
    );
  }, [filterTextEquipment, resetPaginationToggleEquipment, prefilteredEquipments, selectedequipments]);

  //big workaround because there is a conflict between handleSelectedRowsChange and defaultSelectedRows, since defaultSelectedRows calls handleSelectedRowsChange
  //see https://github.com/jbetancur/react-data-table-component/issues/955
  // let isInitialized = false;
  // const handleSelectedRowsChange = state => {
  //   console.log("handleSelectedRowsChange");
  //   console.log(state.selectedRows);
  //   if (state.selectedRows.length === selectedequipments.length) {
  //     isInitialized = true;
  //   }
  //   if (isInitialized === true && state.selectedRows.length !== selectedequipments.length)
  //     setSelectedequipments(state.selectedRows);
  // };

  // const defaultSelectedRows = (row) => selectedequipments.some((eq) => eq.id == row.id);



  const conditionalRowStyles = [
    {
      when: row => selectedequipments.find((eq) => eq.id === row.id),
      style: {
        backgroundColor: '#6B3CC8',
        color: 'white',
      },
    },
  ];
  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <GridContainer>
                    <GridItem xs={12} sm={7} md={7}>
                      <div>
                        <CustomSelect
                          inputTitle={automationText.hardware}
                          selectValue={type}
                          handleSelectValueChange={handleTypeChange}
                          data={filteredHardwareData}
                        />
                      </div>
                    </GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <DataTable
                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                    noDataComponent={<NoData>{"Aucun équipement"}</NoData>}
                    noHeader={true}
                    columns={equipmentsColumns}
                    persistTableHead
                    pagination
                    subHeader
                    data={filteredItemsEquipments}
                    paginationComponentOptions={{
                      noRowsPerPage: false,
                      rowsPerPageText: "Lignes par page",
                      rangeSeparatorText: "sur",
                      selectAllRowsItem: false,
                      selectAllRowsItemText: "Selectionner toutes les lignes",
                    }}
                    // onSelectedRowsChange={handleSelectedRowsChange}
                    // selectableRows={true}
                    // selectableRowSelected={defaultSelectedRows}
                    defaultPageSize={10}
                    filterable={true}
                    defaultSortFieldId={1}
                    manual={true}
                    paginationResetDefaultPage={resetPaginationToggleEquipment}
                    subHeaderComponent={subHeaderComponentMemoEquipment}
                    onRowClicked={handleOnRowClicked}
                    conditionalRowStyles={conditionalRowStyles}
                    pointerOnHover={true}
                    subHeaderAlign={"left"}
                  />
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Valider
        </Button>
      </form>

    </>
  );
}

export default EquipmentsDialog;
